import { useSelector } from "react-redux";
import { RootState } from "store/reducers";

export const CLOUD_VIDEOS_MAX_DURATION_CLAIM = "cloudvideos:maxduration";

export const secondsToMinutes = (seconds: number | undefined) =>
    Math.floor((seconds ?? 0) / 60);

export const useCloudVideosLimitMode = () => {
    const claimMaxSeconds =
        useSelector(
            (s: RootState) =>
                s.user.userInfo?.Claims?.Details?.FeatureLimitClaims?.[
                    CLOUD_VIDEOS_MAX_DURATION_CLAIM
                ]
        ) ?? 0;

    return { isMinutesMode: claimMaxSeconds > 0, claimMaxSeconds };
};
